import { ModalController } from './modal-controller';

export class PurchasePointsController extends ModalController {
  static targets = ['pointsUnit', 'totalPrice', 'totalPoints', 'termCheck', 'amount', 'modal']

  connect() {
    this.setTotal(this.pointsUnitTarget.value);
  }

  openModal(event) {
    // フォームのデフォルト送信を防止
    event.preventDefault();

    // イベントの親要素への伝播を防止
    // submitイベントがdocumentまで伝播すると、Railsのdata-disable-with機能が発動し、
    // 送信ボタンがdisabledになる。その結果、2回目以降のボタンクリックが無効化され、
    // モーダルを開くことができなくなる。stopPropagation()で伝播を止めることで、
    // この二重送信防止機能の発動を防ぎ、ボタンを有効な状態に保つ。
    event.stopPropagation();

    if (this.pointsUnitTarget.value === '' || !this.termCheckTarget.checked) {
      return;
    }

    super.openModal(event);
  }

  changePointsUnit(event) {
    this.setTotal(event.target.value);
  }

  setTotal(unit) {
    this.totalPriceTarget.textContent = this.get_total(unit).toLocaleString('en-US');
    this.totalPointsTarget.textContent = this.get_total(unit).toLocaleString('en-US');
    this.amountTarget.value = unit;
  }

  get_total(unit) {
    return unit * 10000
  }
}